/* eslint-disable no-alert */
import React, { useMemo } from 'react';
import { history, useIntl } from 'umi';
import DraggableFloat from '../DraggableFloat';

interface IGuideButtonProps extends React.HTMLAttributes<HTMLDivElement> {}

const GuideButton = (props: IGuideButtonProps) => {
  const intl = useIntl();

  const itemList = useMemo(
    () => [
      {
        title: intl.formatMessage({ id: '服務簡介' }),
        onClick: () => {
          // 跳轉到 foster-complete-submission頁面
          history.push('/fosterappnote?index=1');
        },
      },
      {
        title: intl.formatMessage({ id: '申請對象' }),
        onClick: () => {
          history.push('/fosterappnote?index=2');
        },
      },
      {
        title: intl.formatMessage({ id: '內容' }),
        onClick: () => {
          history.push('/fosterappnote?index=3');
        },
      },
      {
        title: intl.formatMessage({ id: '申請條件' }),
        onClick: () => {
          history.push('/fosterappnote?index=4');
        },
      },
      {
        title: intl.formatMessage({ id: '申請流程' }),
        onClick: () => {
          history.push('/fosterappnote?index=5');
        },
      },
      {
        title: intl.formatMessage({ id: '聯絡資料' }),
        onClick: () => {
          history.push('/fosterappnote?index=6');
        },
      },
    ],
    [intl],
  );

  return <DraggableFloat itemList={itemList} />;
};

export default GuideButton;
